import { Component, OnInit, Input, Output } from '@angular/core';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { FormGroup, FormControl } from '@angular/forms';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuditoriaService } from 'src/app/services/http/auditoria.service';

@Component({
  selector: 'app-list-associacao-auditoria',
  templateUrl: './list-associacao-auditoria.component.html',
  styleUrls: ['./list-associacao-auditoria.component.scss']
})
export class ListAssociacaoAuditoriaComponent implements OnInit {

  @Input() respostaFormulario;

  tableLoading: boolean = false;
  listaResultado = [];
  total: number = 0;
  listaAuditores = [];

  pesquisa = new FormGroup({
    'nomeFantasia': new FormControl(''),
    'nomeFantasiaUnidadeAuditora': new FormControl(''),
  });

  params = {
    filter: {
      nomeFantasia: '',
      nomeFantasiaUnidadeAuditora: ''
    },
    sorting: {
      nomeFantasia: 'asc',
      nomeFantasiaUnidadeAuditora: ''
    },
    data: new Date(),
    per_page: 10,
    page: 1
  }

  first: number = 0;
  object: any = {};
  dynamicdownloadName: string = "Associação de Auditoria"
 
 cols: any = [
    { field: 'nomeFantasia', header: 'Unidade Cliente' },
    { field: 'nomeFantasiaUnidadeAuditora', header: 'Auditor(a)' },
  ];

  constructor(private auditoriaService: AuditoriaService, private modalMsgService: ModalMsgService, private modalService: NgbModal) { }

  ngOnInit() {
    this.updateResult();

    this.pesquisa.valueChanges.pipe(distinctUntilChanged(), debounceTime(800)).subscribe(r => {
      this.params.filter = { ...this.params.filter, ...r };
      this.updateResult();
    });
  }

  removeEmpty = (obj) => {
    Object.keys(obj).forEach((key) => (obj[key] == '') && delete obj[key]);
    return obj;
  }

  changeOrder() {
    this.updateResult();
  }

  setPageSize(size) {
    this.params.per_page = size;
    this.updateResult();
  }

  nextPage() {
    this.updateResult();
  }

  updateResult() {
    this.params.data = new Date();
    let dataUpdate = this.params.data;
    let params = { ...this.params };
    params.sorting = this.removeEmpty({...this.params.sorting});
    params.filter = this.removeEmpty({...this.params.filter});
    this.auditoriaService.getListaAssociacaoAuditoriaFiltro(params).then(r => {
      if (dataUpdate == this.params.data) {
        this.total = r.total || 0;
        this.listaResultado = r.lista || [];
      }
    });
  }

  removerAssociacaoAuditoria(associacao) {
    // Envia esse JSON com os ID's para serem deletados
    let dados = {
      id: associacao.id,
      idUnidadeAuditora: associacao.idUnidadeAuditora
    }
    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Remover Associção de Auditoria';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.auditoriaService.deletarAssociacaoAuditoria(dados, justificativa)
          .then(r => this.updateResult());
      } else {
        this.modalMsgService.openDialog('Erro ao remover Associação de Auditoria',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao remover Associação de Auditoria',
      'Informe uma Justificativa para concluir a operação', 'danger'));
  }

}
